import {isArray} from "lodash";

export default {
    data() {
        return {
            hasTransfusions: false,
            transfusions: [],
        };
    },
    methods: {
        transfusionCreateTransfusions(transfusions, fields) {
            let returnedTransfusions = fields.transfusion_type.choices.map(element => {
                return {
                    selected: false,
                    date: null,
                    transfusion_type: element.value,
                    amount: null,
                };
            });

            if (this.transfusionHasTransfusions(transfusions)) {
                transfusions.forEach(surgeryTransfusion => {
                    returnedTransfusions.forEach(transfusion => {
                        if (surgeryTransfusion.transfusion_type === transfusion.transfusion_type) {
                            transfusion.selected = true;
                            transfusion.amount = surgeryTransfusion.amount;
                            transfusion.date = surgeryTransfusion.date;
                        }
                    });
                });
            }

            return returnedTransfusions;
        },
        transfusionHasTransfusions(transfusions) {
            return isArray(transfusions) && transfusions.length > 0;
        },
        transfusionGetTransfusionForStoring() {
            if (this.hasTransfusions) {
                let transfusions = [];
                this.transfusions.forEach(transfusion => {
                    if (transfusion.selected) {
                        transfusions.push({
                            transfusion_type: transfusion.transfusion_type,
                            amount: transfusion.amount,
                            date: transfusion.date,
                        });
                    }
                });
                return transfusions;
            }
            return [];
        }
    },
};